export const FAVOURITES_TEXT = {
  'account.loading_your_favourites': {
    'en-GB': 'Loading your favourites...',
    'nl-NL': 'Je favorieten laden...',
  },
  'account.remove_your_favourites': {
    'en-GB': 'Remove from favourites?',
    'nl-NL': 'Verwijderen uit favorieten?',
  },
  'account.are_you_sure_you_want_to_remove_this': {
    'en-GB': 'Are you sure you want to remove this?',
    'nl-NL': 'Weet je zeker dat je dit wilt verwijderen?',
  },
  'account.remove': {
    'en-GB': 'Remove',
    'nl-NL': 'Verwijderen',
  },
  'account.cancel': {
    'en-GB': 'Cancel',
    'nl-NL': 'Annuleren',
  },
  'account.cancel_remove': {
    'en-GB': 'Cancel remove',
    'nl-NL': 'Verwijderen ongedaan maken',
  },
  'account.add_some_favourites': {
    'en-GB': 'Add some favourites!',
    'nl-NL': 'Voeg favorieten toe!',
  },
  'account.tap_the_heart_next_to_the_{{category}}_you_love_and_well_save_them_here_for_later':
    {
      'en-GB': (c: { category: string }) => {
        return `Tap the heart next to the ${c.category} you love and we'll save them here for later.`
      },
      'nl-NL': (c: { category: string }) => {
        return `Tik op het hartje naast de ${c.category} waar je blij van wordt en wij slaan ze hier op voor later.`
      },
    },
  'account.shop_{{category}}': {
    'en-GB': (c: { category: string }) => {
      return `Shop ${c.category}`
    },
    'nl-NL': (c: { category: string }) => {
      return `${c.category} shoppen`
    },
  },
  'account.href_personalised_cards_all': {
    'en-GB': 'personalised-cards/all/',
    'nl-NL': 'wenskaarten/alle/',
  },
  'account.href_gifts_all': {
    'en-GB': 'gifts/all/',
    'nl-NL': 'cadeaus/alle/',
  },
  'account.href_gifts': {
    'en-GB': 'gifts/',
  },
  'account.href_flowers_and_plants_all': {
    'en-GB': 'flowers-and-plants/all-flowers/',
    'nl-NL': 'bloemen-en-planten/alle/',
  },
}
